export type CompareValuesFn<ValueType> = (
  valueOfOption: ValueType,
  selectedValue: ValueType,
) => boolean;

/**
 * Default value comparison function to determine the currently selected option.
 */
export const defaultCompareValues: CompareValuesFn<unknown> = (a, b) => a === b;
